import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { TSettings } from '../../services/appconfig/settings.model';
import { SettingsService } from '../../services/settings/settings.service';
import { MODAL_OPTIONS_OVERFLOW } from '../../utils/constants';

@Component({
  selector: 'frodo-overflow-area-dialog',
  templateUrl: './overflow-area-dialog.component.html',
  styleUrls: ['./overflow-area-dialog.component.scss'],
})
export class OverflowAreaDialogComponent implements OnInit, OnDestroy {
  inactivityTimeout: number;
  subscription: Subscription = new Subscription();
  inactivityInterval;

  constructor(
    private dialogRef: MatDialogRef<OverflowAreaDialogComponent>,
    private settingsService: SettingsService
  ) {
    this.subscription.add(
      this.settingsService.getSettings.subscribe((response: TSettings) => {
        this.inactivityTimeout = response.apps.frodo.timeouts.guidedOnloadOrder;
      })
    );
  }

  ngOnInit(): void {
    this.timer();
  }

  timer(): void {
    this.inactivityInterval = setTimeout(() => {
      this.onComplete();
    }, this.inactivityTimeout);
  }

  onCancel(): void {
    this.clearTimeout();
    this.dialogRef.close(MODAL_OPTIONS_OVERFLOW.cancel);
  }

  onComplete(): void {
    this.clearTimeout();
    this.dialogRef.close(MODAL_OPTIONS_OVERFLOW.complete);
  }

  clearTimeout(): void {
    clearTimeout(this.inactivityInterval);
  }

  ngOnDestroy(): void {
    this.clearTimeout();
    this.subscription.unsubscribe();
  }
}
